const appSettings = {
    apiUrl: process.env.NODE_ENV === 'production'
        ? 'https://api.syagent.com'
        // : 'http://localhost:3032'
        : 'https://api.syagent.com'
};

export default appSettings;
